<template>
    <portal to="modals" v-if="openModal">
        <b-modal
            :hideFooter="true"
            @hidden="closeModalFunction"
            v-model="openModal" 
            :title="uLang('app.client_satisfaction_survey')"
            size="lg"
        >
            <b-card class="mb-4 survey-explanation">
                {{ uLang('app.client_satisfaction_survey_explanation') }}
            </b-card>

            <relation-feedback-form :enrolment_id="enrolment_id" />
        </b-modal>
    </portal>
</template>

<script>
import RelationFeedbackForm from "../forms/relation-feedback/form";

export default {
    name: "CoachFeedbackModal",
    props: {
        openModalOuter: {
            type: Boolean,
            required: true
        },
    },
    data() {
        return {
            openModal: this.openModalOuter,
            enrolment_id: null,
        }
    },
    mounted() {
        window.axios.get(route('relation.feedback.showmodal')).then(({data}) => {
            if (data.showModal) {
                this.enrolment_id = data.enrolmentID;
            }
        })
    },

    components: {
        RelationFeedbackForm,
    },

    methods: {
        closeModalFunction() {
            this.$emit('update:show', this.openModal);
        }
    },
    watch: {
        openModalOuter(newVal) {
            this.openModal = newVal;
            this.$emit('update:show', this.openModal);
        }
    }
}
</script>

<style lang="scss" scoped>
.survey-explanation {
    font-size: 1.2rem;
    border-left: 8px solid #5A4587;
    border-bottom: 3px solid #5A4587;
}
</style>

